export const ChangeSlide = (ref) => {
  if (ref.current) {
    const carouselElements = ref.current.containerRef.current.querySelectorAll(
      ".react-multi-carousel-item"
    )

    carouselElements.forEach((element, index) => {
      const isActive = element.classList.contains(
        "react-multi-carousel-item--active"
      )
      const focusableLinks = element.querySelectorAll("a[tabindex]")
      if (isActive) {
        focusableLinks.forEach((link) => {
          link.setAttribute("tabindex", 0)
        })
      } else {
        focusableLinks.forEach((link) => {
          link.setAttribute("tabindex", -1)
        })
      }
    })
  }
}
